
import {
  defineComponent,
  useAsync,
  useContext,
  ref,
  computed,
} from '@nuxtjs/composition-api'
import LazyHydrate from 'vue-lazy-hydration'
import { Pages } from '~/assets/ts/pages'
import TeaserProducts from '~/components/teaser/teaserProducts.vue'
import StylesIndividualStyle from '~/pages/stylesIndividualStyle.vue'
import ElementVideoBanner from '~/components/element/elementVideoBanner.vue'
import ElementSeoText from '~/components/element/elementSeoText.vue'
import breadcrumb from '~/components/Breadcrumb.vue'
import MetaTitle from '~/components/meta/MetaTitle.vue'
import { domainByCountry, leaveShopOnCurrentDomain } from '~/assets/ts/Domains'
import ShopAppointmentButton from '~/components/shopAppointment/shopAppointmentButton.vue'
import { getCountryCode } from '~/assets/ts/Locale'
import Paragraph from '~/components/html/Paragraph.vue'

type shopStructure = {
  shopId: number
  name: {
    main: string
    list: string
    international: string
  }
  address: {
    postalCode: string
    streetAddress: string
    addressLocality: string
    addressCountry: string
  }
  town: string
  slug: string
  geo: any
}

type geoDataType = {
  [key: string]: {
    [key: string]: {
      latitude: number
      longitude: number
      zoom: number
    }
  }
}

export default defineComponent({
  components: {
    Paragraph,
    ShopAppointmentButton,
    ElementSeoText,
    ElementVideoBanner,
    StylesIndividualStyle,
    TeaserProducts,
    LazyHydrate,
    breadcrumb,
    MetaTitle,
  },
  setup() {
    const {
      app: { i18n, router, $content },
    } = useContext()

    let pageRoute = '' as string | null | undefined
    let pageName = '' as string
    let pageStr = '' as string

    const country: string = getCountryCode()
    const iconSize: any = [50, 50]
    const iconAnchor: any = [25, 50]

    const PagesHelper = new Pages()
    pageRoute = PagesHelper.getPageRoute(router)
    pageName = PagesHelper.getPageName(pageRoute)
    pageStr = PagesHelper.getPageStr(pageName)

    /**
     * map
     */

    const shops = ref([] as shopStructure[])
    const geoData = ref({} as geoDataType)
    const currentZoom = ref(1)

    useAsync(async () => {
      if (process.client) {
        shops.value = (await $content('shops', {
          deep: true,
        }).fetch()) as shopStructure[]

        geoData.value = (await $content('geo', 'all').fetch()) as geoDataType
        currentZoom.value = geoData.value[country].center.zoom
      }
    })

    const currentShopId = ref(country + '-0')

    const currentPosition = computed(() => {
      const country = currentShopId.value.substring(0, 2)
      const shopId = parseInt(currentShopId.value.substring(3, 8))

      if (shopId === 0) {
        setTimeout(() => {
          currentZoom.value = geoData.value[country].center.zoom
        }, 300)
        return [
          geoData.value[country].center.latitude,
          geoData.value[country].center.longitude,
        ]
      } else {
        setTimeout(() => {
          currentZoom.value = 11
        }, 300)

        return [
          geoData.value[country][shopId].latitude,
          geoData.value[country][shopId].longitude,
        ]
      }
    })

    return {
      i18n,
      pageRoute,
      pageStr,
      shops,
      country,
      geoData,
      iconSize,
      iconAnchor,
      currentPosition,
      currentZoom,
      currentShopId,
      domainByCountry,
      leaveShopOnCurrentDomain,
    }
  },
})
